import React from 'react';
import TableCoreComponent from './../../reusable/LightTable/TableCoreComponent';
import { PermissionContext, withPermission } from './../../context';
import { userHas, permissions } from "../../permissions";
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router';
import headerActions from './../../reusable/Header/Header.actions';
import api from '../../api/Feeds.api';
import categoriesApi from './../../api/Categories.api';
import { MANAGE_FEEDS_ENTITY_DISPLAY_LIMIT, MANAGE_FEEDS_PAGE_SIZE, PAGE_NAME_MANAGE_FEEDS } from './../../constants';
import { StaticPillList } from './../../reusable/Form/PillList';
import { BoldedCell } from './../../reusable/LightTable/Components';
import { ConfirmModal, ListingPageHeaderPerm as ListingPageHeader } from './../../reusable/LightTable/Components'
import { FeedListingPESTLERiskLinesCell } from './template/FeedListingCellTypes';
import withCounter from './../../reusable/LightTable/hoc/withCounter';
import withSort from './../../reusable/LightTable/hoc/Sortable';
import withSelectionPaginated from './../../reusable/LightTable/hoc/SelectablePaginated';
import withPagination from './../../reusable/LightTable/hoc/Paginated';
import LightTable from './../../reusable/LightTable/VeryLightTable';
import { DeleteButton, Button, ActionLink } from './../../reusable/Form/Buttons';
import PestleHelp from '../../reusable/PestleHelp/PestleHelp';
import { compose } from 'redux';
import {ActionItemsCell, ActiveLabel, DateCell, TextCell} from "../../reusable/LightTable/Components";
import Spinner from "../../reusable/Spinner/Spinner";
import reduxStore from '../../reduxStore';
import { sortBy } from 'lodash';

const Table = compose(
    withPermission,
    withSelectionPaginated,
    withSort,
    withCounter,
    withPagination
)(LightTable);

class FeedListing extends TableCoreComponent {

    constructor(props) {
        super(props);

        this.state = {
            categories: null,
            ...this.state
        }

        const defaultLoadParams = {
            filters:    {query: ""},
            sorting:    reduxStore.getState().user.preferences.pagesTablesSort[PAGE_NAME_MANAGE_FEEDS],
            pagination: {pageNumber: 0, pageSize: MANAGE_FEEDS_PAGE_SIZE},
            reset:      false
        };
        this.defaultLoadParams = this.loadParams = defaultLoadParams;
        this.api = api;

        this.handleSingleDelete = this.handleSingleDelete.bind(this);
        this.handleBulkDelete = this.handleBulkDelete.bind(this);
        this.handleViewFeed = this.handleViewFeed.bind(this);
    }

    componentDidMount() {
        categoriesApi.getCategoryNames().then(categories => {
            this.setState({ categories }, () => {
                super.componentDidMount();
            });
        }).catch(this.fatalError);
        headerActions.updateHeader('feedListing');
    }

    handleEditFeed = (feed) => (e) => {
        this.props.router.push(`/edit-feed/${feed.id}`);
    };

    handleViewFeed(feed) {
        this.props.router.push("/view-feed-content/" + feed.id);
    }

    formatAssignedToColumn(item) {
        if (item.metaData.selectAllThirdParties) {
            return <StaticPillList items={[{ label: <FormattedMessage id="RSS_Feed_UIText_feedListing.allActive" /> }]}/>
        }
        if (item.metaData.thirdParties.length) {
            return <StaticPillList items={item.metaData.thirdParties.map(entity => ({ label: entity }))}
                                   visibleItemCount={MANAGE_FEEDS_ENTITY_DISPLAY_LIMIT}
                                   onShowMore={this.handleEditFeed(item)}
                                   className={"entities"} />
        }
        if (item.metaData.categories.length) {
            if (this.state.categories) {
                const items = item.metaData.categories.map(categoryId =>
                    this.state.categories[categoryId] ? ({ label: this.state.categories[categoryId] }) : false
                )
                if (items.filter(item => item).length !== 0) {
                    return <StaticPillList items={items}
                                           visibleItemCount={MANAGE_FEEDS_ENTITY_DISPLAY_LIMIT}
                                           onShowMore={this.handleEditFeed(item)}
                                           className={"categories"}/>
                }
            } else {
                return <Spinner isLoading/>
            }
        }
        return <TextCell className={"inactive-feed"}><FormattedMessage id="RSS_Feed_UIText_feedListing.feedNotActive"/></TextCell>
    }

    getActionLinks(item) {
        return <ActionItemsCell>
            <ActionLink to={`/edit-feed/${item.id}`}>
                <FormattedMessage id="General_CoreFunctionality_UIText_general.edit" />
            </ActionLink>
            <ActionLink action={this.handleSingleDelete} params={item}>
                <FormattedMessage id='General_CoreFunctionality_UIText_general.delete' />
            </ActionLink>
        </ActionItemsCell>
    }

    /**
     * View function for items in table
     * @param item
     * @param searchTerm
     * @returns {{key, companyTitle: XML, status: string, duns: (string|string|*), categoryIDs: XML, object: *}}
     */
    formatItem(item, searchTerm = "") {
        item.active = item.metaData.selectAllThirdParties || (item.metaData.categories.length > 0) || (item.metaData.thirdParties.length > 0);

        // if it has categories, check if they are still valid
        if (this.state.categories && item.metaData.categories.length) {
            const items = item.metaData.categories.map(categoryId => !!this.state.categories[categoryId])
            if (items.filter(item => item).length === 0) {
                item.active = false;
            }
        }

        return {
            key: item.id,
            title: <BoldedCell value={item.title} searchTerm={searchTerm} />,
            metaData: this.formatAssignedToColumn(item),
            active: <TextCell><ActiveLabel isActive={item.active}/></TextCell>,
            pestle: <FeedListingPESTLERiskLinesCell rowData={item} columnWidth={100} withDiv/>,
            viewFeed: <TextCell><Button action={this.handleViewFeed} params={item}>View Feed</Button></TextCell>,
            lastUpdated: <DateCell timestamp={item.lastUpdated}/>,
            actions: this.getActionLinks(item),
            object: item
        }
    };

    headerItems = [
        {
            key: "title",
            label: <FormattedMessage id="RSS_Feed_UIText_feedListing.feedName" />,
            sortable: true,
            persistableSort: PAGE_NAME_MANAGE_FEEDS
        },
        {
            key: "metaData",
            label: <FormattedMessage id="RSS_Feed_UIText_feedListing.inclusion" />
        },
        {
            key: "active",
            label: <FormattedMessage id='Entities_Edit_UIText_editThirdParty.statusLabel'/>
        },
        {
            key: "pestle",
            label: <div>
                <FormattedMessage id="RSS_Feed_UIText_feedListing.pestleResults" />
                <PestleHelp autoPosition className="top"/>
            </div>
        },
        {
            key: "viewFeed",
            label: ""
        },
        {
            key: "lastUpdated",
            label: <FormattedMessage id={"RSS_Feed_UIText_feedListing.lastUpdated"}/>,
            sortable: true,
            persistableSort: PAGE_NAME_MANAGE_FEEDS
        },
        {
            key: "actions",
            label: ""
        }
    ]

    /**
     * View function for item in selected box
     * @param item
     */
    formatSelectedItem = (item) => <span>{item.title}</span>;

    handleSingleDelete(feed) {
        const activeModal = <ConfirmModal headerTextId="RSS_Feed_Error_feedListing.modal.warning"
                                          primaryTextId="RSS_Feed_UIText_feedListing.modal.userConfirmation"
                                          onClose={this.closeModal}
                                          onConfirmPromise={() => this.deleteFeeds([feed])}/>;
        this.setState({ activeModal })
    }

    handleBulkDelete() {
        const activeModal = <ConfirmModal headerTextId="RSS_Feed_Error_feedListing.modal.warning"
                                          primaryTextId="RSS_Feed_UIText_feedListing.modal.userConfirmation"
                                          onClose={this.closeModal}
                                          onConfirm={this.clearSelections}
                                          onConfirmPromise={() => this.deleteFeeds(this.state.selectedItems.map(item => item.object))} />;
        this.setState({ activeModal });
    }

    deleteFeeds(feeds) {
        return api.deleteFeeds(feeds.map(feed => feed.id)).then(() => {
            if (feeds.length === 1) {
                this.showSuccessPopup("RSS_Feed_UIText_feedListing.deleteSuccessMessageSingle", { feedTitle: feeds[0].title })
            } else {
                this.showSuccessPopup("RSS_Feed_UIText_feedListing.deleteSuccessMessageMultiple");
            }
            this.reloadTable();
        }).catch((e) => {
            this.showGenericError(e, true);
        })
    }

    render = () =>
        <PermissionContext.Provider value={{ canEdit: userHas(permissions.feeds.edit) }}>
            <div className="feed-listing-page listing-page standard-table">
                <ListingPageHeader location={"/add-new-feed"} buttonMessageId="RSS_Feed_UIText_feedListing.createFeed" />
                <div className="feeds-table selectable-table">
                    <Table {...this.getTableProps()}
                           selectedItems={sortBy(this.state.selectedItems, item => item.title.props.value.toLowerCase())}
                           actions={<DeleteButton action={this.handleBulkDelete} disabled={this.state.selectedItems.length === 0} />}
                           fullScreen />
                </div>
                {this.state.activeModal && this.state.activeModal}
            </div>
        </PermissionContext.Provider>
}

export default withRouter(FeedListing);


// WEBPACK FOOTER //
// ./src/scripts/pages/FeedListing/FeedListing.jsx